/* Habibi Scents — Theme JS */
function formatMoney(cents){var fmt=(window.shopData&&window.shopData.moneyFormat)||'£{{amount}}';var amount=(cents/100).toFixed(2);return fmt.replace('{{amount}}',amount).replace('{{amount_no_decimals}}',Math.round(cents/100));}
function showToast(msg){var t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.remove('show');void t.offsetWidth;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},3000);}
function escapeHtml(s){return(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

window.HabibiCart=(function(){
  function open(){document.getElementById('cart-drawer').classList.add('open');document.getElementById('cart-overlay').classList.add('visible');document.body.style.overflow='hidden';fetchAndRender();}
  function close(){document.getElementById('cart-drawer').classList.remove('open');document.getElementById('cart-overlay').classList.remove('visible');document.body.style.overflow='';}
  function fetchAndRender(){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){renderDrawer(c);updateCount(c.item_count);}).catch(function(){});}
  function renderDrawer(cart){
    var el=document.getElementById('cd-items');var foot=document.getElementById('cd-foot');var sub=document.getElementById('cd-subtotal');
    if(!cart.items||!cart.items.length){el.innerHTML='<div class="cd-empty">Your cart is empty.</div>';if(foot)foot.style.display='none';return;}
    var html='';
    cart.items.forEach(function(item){
      var img=item.image?'<img src="'+item.image+'" class="cd-item-img" alt="'+escapeHtml(item.title)+'" width="74" height="74" loading="lazy">':'<div class="cd-item-img" style="background:var(--dark-2)"></div>';
      var variant=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
      html+='<div class="cd-item" data-key="'+item.key+'">'+img+'<div><div class="cd-item-title">'+escapeHtml(item.product_title)+'</div>'+(variant?'<div class="cd-item-variant">'+escapeHtml(variant)+'</div>':'')+'<div class="cd-item-price">'+formatMoney(item.final_line_price)+'</div><div class="cd-item-actions"><div class="cd-qty"><button onclick="HabibiCart.changeQty(\''+item.key+'\','+(item.quantity-1)+')">−</button><span>'+item.quantity+'</span><button onclick="HabibiCart.changeQty(\''+item.key+'\','+(item.quantity+1)+')">+</button></div><button class="cd-remove" onclick="HabibiCart.changeQty(\''+item.key+'\',0)">Remove</button></div></div></div>';
    });
    el.innerHTML=html;
    if(sub)sub.textContent=formatMoney(cart.total_price);
    if(foot)foot.style.display='block';
  }
  function changeQty(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){renderDrawer(c);updateCount(c.item_count);});}
  function addItem(variantId,qty,props){
    var body={id:variantId,quantity:qty||1};
    if(props)body.properties=props;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)return r.json().then(function(d){throw new Error(d.description||'Error');});return r.json();})
      .then(function(){showToast('Added to your bag');open();})
      .catch(function(err){showToast(err.message||'Could not add item');});
  }
  function updateCount(n){var b=document.querySelector('.cart-count-badge');if(!b)return;b.textContent=n;if(n>0)b.classList.add('visible');else b.classList.remove('visible');}
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCount(c.item_count);}).catch(function(){});
  return{open:open,close:close,addItem:addItem,changeQty:changeQty,fetchAndRender:fetchAndRender};
})();

function initProductPage(){
  var form=document.getElementById('product-form');if(!form)return;
  var variantInput=document.getElementById('variant-id');var priceEl=document.getElementById('product-price-display');var compareEl=document.getElementById('product-compare-price');var atcBtn=document.getElementById('atc-btn');var mainImg=document.getElementById('product-main-img');
  var variantData=[];try{variantData=JSON.parse(document.getElementById('variant-data').textContent||'[]');}catch(e){}
  var selectedOptions={};
  document.querySelectorAll('.variant-options[data-option-index]').forEach(function(group){
    var idx=group.getAttribute('data-option-index');
    group.querySelectorAll('.variant-btn').forEach(function(btn){
      btn.addEventListener('click',function(){group.querySelectorAll('.variant-btn').forEach(function(b){b.classList.remove('selected');});btn.classList.add('selected');selectedOptions[idx]=btn.getAttribute('data-value');updateVariant();});
    });
  });
  function updateVariant(){
    var match=variantData.find(function(v){return v.options.every(function(opt,i){return!selectedOptions[i]||selectedOptions[i]===opt;});});
    if(!match)return;
    if(variantInput)variantInput.value=match.id;
    if(priceEl)priceEl.textContent=formatMoney(match.price);
    if(compareEl){if(match.compare_at_price>match.price){compareEl.textContent=formatMoney(match.compare_at_price);compareEl.style.display='';}else{compareEl.textContent='';compareEl.style.display='none';}}
    if(atcBtn){if(match.available){atcBtn.disabled=false;atcBtn.textContent='Add to Bag';}else{atcBtn.disabled=true;atcBtn.textContent='Sold Out';}}
    if(mainImg&&match.featured_image)mainImg.src=match.featured_image.src;
  }
  var qtyInput=document.getElementById('qty-input');var qtyMinus=document.getElementById('qty-minus');var qtyPlus=document.getElementById('qty-plus');
  if(qtyInput&&qtyMinus&&qtyPlus){qtyMinus.addEventListener('click',function(){var v=parseInt(qtyInput.value)||1;if(v>1)qtyInput.value=v-1;});qtyPlus.addEventListener('click',function(){qtyInput.value=(parseInt(qtyInput.value)||1)+1;});}
  form.addEventListener('submit',function(e){
    e.preventDefault();var vid=variantInput?parseInt(variantInput.value):null;var qty=qtyInput?parseInt(qtyInput.value)||1:1;if(!vid)return;
    atcBtn.textContent='Adding…';atcBtn.disabled=true;
    HabibiCart.addItem(vid,qty).then(function(){atcBtn.disabled=false;atcBtn.textContent='Add to Bag';});
  });
  document.querySelectorAll('.product-thumb').forEach(function(thumb){thumb.addEventListener('click',function(){if(mainImg)mainImg.src=thumb.getAttribute('data-src');document.querySelectorAll('.product-thumb').forEach(function(t){t.classList.remove('active');});thumb.classList.add('active');});});
}

function initProductTabs(){
  var btns=document.querySelectorAll('.product-tab-btn');if(!btns.length)return;
  btns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var target=btn.getAttribute('data-tab');
      document.querySelectorAll('.product-tab-btn').forEach(function(b){b.classList.remove('active');});
      document.querySelectorAll('.product-tab-panel').forEach(function(p){p.classList.remove('active');});
      btn.classList.add('active');
      var panel=document.getElementById('tab-'+target);if(panel)panel.classList.add('active');
    });
  });
}

function initCartPage(){
  document.querySelectorAll('.cart-item-qty button').forEach(function(btn){
    btn.addEventListener('click',function(){var row=btn.closest('[data-key]');var key=row&&row.getAttribute('data-key');var input=row&&row.querySelector('.cart-item-qty input');if(!key||!input)return;var delta=btn.getAttribute('data-dir')==='up'?1:-1;var newQty=Math.max(0,parseInt(input.value)+delta);input.value=newQty;fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:newQty})}).then(function(){window.location.reload();});});
  });
  document.querySelectorAll('.cart-remove').forEach(function(btn){btn.addEventListener('click',function(){var key=btn.getAttribute('data-key');if(!key)return;fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})}).then(function(){window.location.reload();});});});
}

function initFilters(){
  var chips=document.querySelectorAll('.filter-chip[data-filter]');
  var sortSelect=document.getElementById('sort-select');
  var cards=document.querySelectorAll('.collection-grid .product-card');
  if(!chips.length&&!sortSelect)return;
  var activeFilters={brand:'all'};
  function applyFilters(){
    cards.forEach(function(card){
      var show=true;
      if(activeFilters.brand!=='all'&&card.getAttribute('data-brand')!==activeFilters.brand)show=false;
      card.classList.toggle('hidden',!show);
    });
  }
  chips.forEach(function(chip){
    chip.addEventListener('click',function(){
      var filter=chip.getAttribute('data-filter');var value=chip.getAttribute('data-value');
      document.querySelectorAll('.filter-chip[data-filter="'+filter+'"]').forEach(function(c){c.classList.remove('active');});
      chip.classList.add('active');activeFilters[filter]=value;applyFilters();
    });
  });
  if(sortSelect){
    var urlParams=new URLSearchParams(window.location.search);var current=urlParams.get('sort_by')||'';if(current)sortSelect.value=current;
    sortSelect.addEventListener('change',function(){var url=new URL(window.location.href);url.searchParams.set('sort_by',sortSelect.value);window.location.href=url.toString();});
  }
}

function initSearchBar(){
  var btn=document.getElementById('header-search-btn');var bar=document.getElementById('search-bar');var closeBtn=document.getElementById('search-close');var input=bar&&bar.querySelector('.search-input');
  if(!btn||!bar)return;
  btn.addEventListener('click',function(){bar.classList.toggle('open');if(bar.classList.contains('open')&&input)setTimeout(function(){input.focus();},80);});
  if(closeBtn)closeBtn.addEventListener('click',function(){bar.classList.remove('open');});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')bar.classList.remove('open');});
}

function initMobileNav(){
  var toggle=document.getElementById('mobile-nav-toggle');var nav=document.getElementById('mobile-nav');
  if(toggle&&nav){toggle.addEventListener('click',function(){nav.classList.toggle('open');});}
  [].slice.call(document.querySelectorAll('.mnav-toggle')).forEach(function(btn){
    btn.addEventListener('click',function(){
      var group=btn.closest('.mnav-group');
      [].slice.call(document.querySelectorAll('.mnav-group')).forEach(function(g){if(g!==group)g.classList.remove('open');});
      group.classList.toggle('open');
    });
  });
}

function initHeaderScroll(){
  var header=document.getElementById('site-header');if(!header)return;
  window.addEventListener('scroll',function(){
    if(window.scrollY>60){header.classList.add('scrolled');}else{header.classList.remove('scrolled');}
  },{passive:true});
}

function initCounters(){
  var tiles=document.querySelectorAll('.hero-tile');if(!tiles.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      var numEl=e.target.querySelector('.hero-tile-num');if(!numEl)return;
      var raw=numEl.textContent.trim();
      var match=raw.match(/^(\d+)(.*)/);if(!match)return;
      var end=parseInt(match[1]),suffix=match[2],startTime=null;
      function tick(ts){
        if(!startTime)startTime=ts;
        var p=Math.min((ts-startTime)/1200,1);
        var ease=1-Math.pow(1-p,3);
        numEl.textContent=Math.round(end*ease)+suffix;
        if(p<1)requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      obs.unobserve(e.target);
    });
  },{threshold:.6});
  tiles.forEach(function(t){obs.observe(t);});
}

function initReveal(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('visible');});return;
  }
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target);}
    });
  },{threshold:.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el);});
}

function resizeImg(src,size){return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/,'_'+size+'$1$3');}

window.HabibiQV=(function(){
  var overlay,body,closeBtn;
  var currentVariantId=null;
  var allVariants=[];
  var selectedOptions={};

  function init(){
    overlay=document.getElementById('qv-overlay');
    body=document.getElementById('qv-body');
    closeBtn=document.getElementById('qv-close');
    if(!overlay)return;
    overlay.addEventListener('click',function(e){if(e.target===overlay)close();});
    if(closeBtn)closeBtn.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&overlay.classList.contains('open'))close();});
    document.addEventListener('click',function(e){
      var btn=e.target.closest('.product-card-qv');
      if(btn){e.preventDefault();open(btn.dataset.handle);}
    });
  }

  function open(handle){
    if(!overlay||!body)return;
    body.innerHTML='<div class="qv-loading">Loading…</div>';
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    fetch('/products/'+handle+'.js')
      .then(function(r){return r.json();})
      .then(function(p){render(p);})
      .catch(function(){body.innerHTML='<div class="qv-loading">Could not load product.</div>';});
  }

  function close(){
    if(!overlay)return;
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }

  function render(product){
    allVariants=product.variants;
    selectedOptions={};
    var first=allVariants.find(function(v){return v.available;})||allVariants[0];
    currentVariantId=first.id;

    var hasOptions=product.options&&!(product.options.length===1&&product.options[0]==='Title');
    if(hasOptions){first.options.forEach(function(o,i){selectedOptions[i]=o;});}

    var optHtml='';
    if(hasOptions){
      product.options.forEach(function(name,idx){
        var vals=[];
        allVariants.forEach(function(v){if(vals.indexOf(v.options[idx])<0)vals.push(v.options[idx]);});
        var sel=first.options[idx];
        optHtml+='<div class="qv-opt-group" data-option-index="'+idx+'">';
        optHtml+='<span class="qv-opt-label">'+escapeHtml(name)+': <em>'+escapeHtml(sel)+'</em></span>';
        optHtml+='<div class="qv-opt-btns">';
        vals.forEach(function(v){optHtml+='<button type="button" class="qv-opt-btn'+(v===sel?' selected':'')+'" data-value="'+escapeHtml(v)+'">'+escapeHtml(v)+'</button>';});
        optHtml+='</div></div>';
      });
    }

    var mainSrc=product.images.length?resizeImg(product.images[0].src,'800x800'):'';
    var thumbsHtml='';
    if(product.images.length>1){
      product.images.forEach(function(img,i){
        thumbsHtml+='<img src="'+resizeImg(img.src,'160x160')+'" class="qv-thumb'+(i===0?' active':'')+'" data-src="'+resizeImg(img.src,'800x800')+'" loading="lazy" alt="">';
      });
    }

    var priceHtml='';
    if(first.compare_at_price>first.price)priceHtml+='<span class="qv-price-was">'+formatMoney(first.compare_at_price)+'</span>';
    priceHtml+='<span class="qv-price-now">'+formatMoney(first.price)+'</span>';

    var atcDisabled=first.available?'':' disabled';
    var atcText=first.available?'Add to Bag':'Sold Out';

    body.innerHTML=
      '<div class="qv-gallery">'+
        (mainSrc?'<img src="'+mainSrc+'" class="qv-main-img" id="qv-main-img" alt="'+escapeHtml(product.title)+'">':'')+
        (thumbsHtml?'<div class="qv-thumbs">'+thumbsHtml+'</div>':'')+
      '</div>'+
      '<div class="qv-info">'+
        (product.vendor?'<p class="qv-vendor">'+escapeHtml(product.vendor)+'</p>':'')+
        '<h2 class="qv-title">'+escapeHtml(product.title)+'</h2>'+
        '<div class="qv-price-row" id="qv-price-row">'+priceHtml+'</div>'+
        (optHtml?'<div class="qv-options">'+optHtml+'</div>':'')+
        '<div class="qv-atc-row">'+
          '<div class="qv-qty">'+
            '<button type="button" class="qv-qty-btn" id="qv-qty-minus">−</button>'+
            '<input type="number" class="qv-qty-input" id="qv-qty-input" value="1" min="1" max="99">'+
            '<button type="button" class="qv-qty-btn" id="qv-qty-plus">+</button>'+
          '</div>'+
          '<button class="qv-atc-btn" id="qv-atc-btn"'+atcDisabled+'>'+atcText+'</button>'+
        '</div>'+
        '<a href="/products/'+product.handle+'" class="qv-full-link">View Full Details &rarr;</a>'+
      '</div>';

    var qtyInput=document.getElementById('qv-qty-input');
    var qtyMinus=document.getElementById('qv-qty-minus');
    var qtyPlus=document.getElementById('qv-qty-plus');
    if(qtyMinus)qtyMinus.addEventListener('click',function(){var v=parseInt(qtyInput.value)||1;if(v>1)qtyInput.value=v-1;});
    if(qtyPlus)qtyPlus.addEventListener('click',function(){qtyInput.value=(parseInt(qtyInput.value)||1)+1;});

    [].slice.call(body.querySelectorAll('.qv-thumb')).forEach(function(thumb){
      thumb.addEventListener('click',function(){
        var img=document.getElementById('qv-main-img');if(img)img.src=thumb.dataset.src;
        [].slice.call(body.querySelectorAll('.qv-thumb')).forEach(function(t){t.classList.remove('active');});
        thumb.classList.add('active');
      });
    });

    [].slice.call(body.querySelectorAll('.qv-opt-group')).forEach(function(group){
      var idx=parseInt(group.dataset.optionIndex);
      var lbl=group.querySelector('em');
      [].slice.call(group.querySelectorAll('.qv-opt-btn')).forEach(function(btn){
        btn.addEventListener('click',function(){
          [].slice.call(group.querySelectorAll('.qv-opt-btn')).forEach(function(b){b.classList.remove('selected');});
          btn.classList.add('selected');
          selectedOptions[idx]=btn.dataset.value;
          if(lbl)lbl.textContent=btn.dataset.value;
          updateVariant();
        });
      });
    });

    var atcBtn=document.getElementById('qv-atc-btn');
    if(atcBtn){
      atcBtn.addEventListener('click',function(){
        if(!currentVariantId)return;
        var qty=parseInt(qtyInput?qtyInput.value:1)||1;
        atcBtn.textContent='Adding…';atcBtn.disabled=true;
        HabibiCart.addItem(currentVariantId,qty).then(function(){close();});
      });
    }
  }

  function updateVariant(){
    var match=allVariants.find(function(v){return v.options.every(function(opt,i){return!selectedOptions[i]||selectedOptions[i]===opt;});});
    if(!match)return;
    currentVariantId=match.id;
    var priceEl=document.getElementById('qv-price-row');
    if(priceEl){
      var html='';
      if(match.compare_at_price>match.price)html+='<span class="qv-price-was">'+formatMoney(match.compare_at_price)+'</span>';
      html+='<span class="qv-price-now">'+formatMoney(match.price)+'</span>';
      priceEl.innerHTML=html;
    }
    var atcBtn=document.getElementById('qv-atc-btn');
    if(atcBtn){atcBtn.disabled=!match.available;atcBtn.textContent=match.available?'Add to Bag':'Sold Out';}
    if(match.featured_image){var img=document.getElementById('qv-main-img');if(img)img.src=resizeImg(match.featured_image.src,'800x800');}
  }

  return{init:init,open:open,close:close};
})();

document.addEventListener('DOMContentLoaded',function(){
  initMobileNav();
  initReveal();
  initProductPage();
  initProductTabs();
  initCartPage();
  initFilters();
  initSearchBar();
  initHeaderScroll();
  initCounters();
  HabibiQV.init();
});
